import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { authMe } from "@/lib/api";
import { Zap, LogIn } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    authMe().then(u => { if (u) nav("/admin/dashboard"); }).catch(()=>{});
  }, []);

  function googleLogin() {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  }

  return (
    <div className="min-h-screen bg-[#06080F] text-white flex items-center justify-center px-5 hero-glow relative overflow-hidden">
      <div className="absolute inset-0 dot-grid opacity-30"/>
      <div className="relative glass p-8 sm:p-10 w-full max-w-md">
        <img src="https://customer-assets-jai6qajn.emergentagent.net/job_build-framework-27/artifacts/xu1ebv9g_MOOLAH%20LOGO.jpg" alt="Moolah Tech" className="h-14 w-14 rounded-2xl object-cover shadow-[0_0_24px_rgba(56,189,248,0.35)] mb-5"/>
        <div className="eyebrow">Moolah Tech Admin</div>
        <h1 className="text-3xl font-bold mt-2 leading-tight">Sign in to manage <span className="brand-gradient">bootcamp registrations.</span></h1>
        <p className="text-slate-400 mt-3 text-sm">Only authorized admins can access this dashboard.</p>

        <button
          data-testid="admin-google-login-btn"
          onClick={googleLogin}
          className="mt-8 w-full cta-primary inline-flex items-center justify-center gap-2">
          <LogIn className="w-4 h-4"/> Sign in with Google
        </button>

        <a href="/" className="mt-6 text-slate-500 hover:text-cyan-300 text-xs font-mono uppercase tracking-widest inline-block">← Back to site</a>
      </div>
    </div>
  );
}
